/* WakeUp 2.5.1 - PostHog core. No remote requests before explicit consent. */
(function () {
  'use strict';
  if (window.WUBPH) return;
  var config = window.WUBPHSettings;
  if (!config || !/^phc_[A-Za-z0-9]+$/.test(config.projectKey)) return;
  var ph = null, requested = false, enabled = false;
  function consent() {
    try {
      var api = window.Shopify && window.Shopify.customerPrivacy;
      return !!api && api.analyticsProcessingAllowed() === true &&
        api.currentVisitorConsent().analytics === 'yes';
    } catch (_) { return false; }
  }
  function urlWithoutQuery(input) {
    try {
      var url = new URL(input, window.location.href);
      return /^(http|https):$/.test(url.protocol) ? url.origin + url.pathname : '';
    } catch (_) { return ''; }
  }
  function beforeSend(event) {
    if (!consent()) return null;
    if (event && event.properties) {
      ['$current_url', '$referrer', '$initial_referrer', '$initial_current_url'].forEach(function (key) {
        if (event.properties[key]) event.properties[key] = urlWithoutQuery(event.properties[key]);
      });
    }
    return event;
  }
  function capture(name, properties) {
    if (!ph || !enabled || !consent()) return false;
    var data = Object.assign({
      wub_environment: (window.Shopify && window.Shopify.theme && String(window.Shopify.theme.role || '').toLowerCase() === 'main') ? 'production' : 'preview',
      wub_theme_id: (window.Shopify && window.Shopify.theme && window.Shopify.theme.id) ? String(window.Shopify.theme.id) : '',
      page_type: String(config.pageType || ''),
      currency: 'EUR'
    }, properties || {});
    ph.capture(name, data);
    return true;
  }
  function enable() {
    if (!consent()) return;
    if (!ph) { start(); return; }
    if (enabled) return;
    ph.opt_in_capturing({ captureEventName: false });
    enabled = true;
    capture('$pageview', { $current_url: urlWithoutQuery(window.location.href) });
    document.dispatchEvent(new CustomEvent('wub:posthog-ready'));
  }
  function disable() {
    enabled = false;
    if (!ph) return;
    try { ph.stopSessionRecording(); } catch (_) {}
    try { ph.opt_out_capturing({ clear_persistence: true }); } catch (_) {}
  }
  function sync() { if (consent()) enable(); else disable(); }
  function start() {
    if (requested || !consent()) return;
    if (window.posthog) return; // Fail closed on duplicate SDK.
    requested = true;
    (function (doc, sdk) {
      if (sdk.__SV) return;
      window.posthog = sdk;
      sdk._i = [];
      sdk.init = function (token, settings, name) {
        function stub(target, method) {
          var parts = method.split('.');
          if (parts.length === 2) { target = target[parts[0]]; method = parts[1]; }
          target[method] = function () { target.push([method].concat([].slice.call(arguments))); };
        }
        var element = doc.createElement('script');
        element.type = 'text/javascript';
        element.async = true;
        element.crossOrigin = 'anonymous';
        element.src = 'https://eu-assets.i.posthog.com/static/array.js';
        doc.head.appendChild(element);
        var instance = sdk;
        if (typeof name !== 'undefined') instance = sdk[name] = [];
        else name = 'posthog';
        instance.people = instance.people || [];
        'init capture identify alias people.set people.set_once reset opt_in_capturing opt_out_capturing'.split(' ').forEach(function (method) {
          stub(instance, method);
        });
        sdk._i.push([token, settings, name]);
      };
      sdk.__SV = 1;
    })(document, window.posthog || []);
    window.posthog.init(config.projectKey, {
      api_host: 'https://eu.i.posthog.com',
      ui_host: 'https://eu.posthog.com',
      autocapture: {
        dom_event_allowlist: ['click'],
        element_allowlist: ['a', 'button'],
        css_selector_ignorelist: ['.ph-no-autocapture', '[data-ph-no-autocapture]', 'input', 'textarea', 'select', '[contenteditable]', '[data-ph-block]']
      },
      capture_pageview: false,
      capture_pageleave: true,
      capture_dead_clicks: true,
      capture_exceptions: true,
      capture_performance: true,
      disable_session_recording: false,
      session_recording: {
        maskAllInputs: true,
        maskTextSelector: '*',
        blockSelector: '[data-ph-block], .ph-no-capture'
      },
      enable_recording_console_log: false,
      disable_surveys: true,
      advanced_disable_flags: true,
      person_profiles: 'never',
      opt_out_capturing_by_default: true,
      persistence: 'localStorage',
      respect_dnt: true,
      save_referrer: false,
      store_google: false,
      before_send: beforeSend,
      loaded: function (sdk) {
        ph = sdk;
        if (consent()) enable();
        else disable();
      }
    });
  }
  window.WUBPH = Object.freeze({
    capture: capture,
    status: function () {
      return { consent: consent(), sdkRequested: requested, sdkReady: !!ph,
        enabled: enabled, recordingEnabled: enabled && consent(), project: 'WakeUp' };
    }
  });
  document.addEventListener('visitorConsentCollected', sync);
  window.addEventListener('pageshow', sync);
  document.addEventListener('visibilitychange', function () {
    if (!document.hidden) sync();
  });
  function ready() {
    sync();
    if (window.Shopify && typeof window.Shopify.loadFeatures === 'function') {
      window.Shopify.loadFeatures(
        [{ name: 'consent-tracking-api', version: '0.2' }],
        function (error) { if (!error) sync(); }
      );
    }
    window.setTimeout(sync, 700);
    window.setTimeout(sync, 2500);
  }
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', ready, { once: true });
  } else ready();
})();
